import React from 'react'
import Dialog from '~/components/Dialog'
import { formatNumber } from '~/utils/helpers'

interface ValidationItem {
  groupName: string
  value: number
  min: number
  max: number
}

interface Props {
  isOpen: boolean
  warnings: ValidationItem[]
  errors: ValidationItem[]
  handleClose: () => void
  handleContinue: () => void
}

const DryMatterValuesModal: React.FC<Props> = (props) => {
  const { isOpen, warnings, errors, handleClose, handleContinue } = props
  const hasErrors = errors.length > 0
  const hasWarnings = warnings.length > 0

  return <Dialog
    textHeader={hasErrors ? 'Trockenmassewerte' : 'Warnung'}
    isDialogOpen={isOpen}
    textClose={'Abbrechen'}
    textSubmit={hasErrors ? undefined : 'Fortfahren'}
    handleClose={handleClose}
    handleSubmit={hasErrors ? undefined : handleContinue}
    textContent={
      <div style={{ textAlign: 'center' }}>
        {hasErrors && (
          <div style={{ marginBottom: hasWarnings ? 20 : 0 }}>
            <div style={{ fontWeight: 'bold', color: '#9f3a38', marginBottom: 10 }}>
              {'Die folgenden Gruppen haben Trockenmassewerte außerhalb des zulässigen Bereichs:'}
            </div>
            {errors.map((error, index) => (
              <div key={index} style={{ color: '#9f3a38', marginBottom: 5 }}>
                <strong>{error.groupName}</strong>: {formatNumber(error.value)} kg TM/Tag
                ({`zulässig: ${error.min} - ${error.max} kg TM/Tag`})
              </div>
            ))}
          </div>
        )}
        {hasWarnings && (
          <div>
            <div style={{ fontWeight: 'bold', color: '#f2711c', marginBottom: 10 }}>
              {'Die folgenden Gruppen haben Trockenmassewerte außerhalb des empfohlenen Bereichs:'}
            </div>
            {warnings.map((warning, index) => (
              <div key={index} style={{ color: '#f2711c', marginBottom: 5 }}>
                <strong>{warning.groupName}</strong>: {formatNumber(warning.value)} kg TM/Tag
                ({`empfohlen: ${warning.min} - ${warning.max} kg TM/Tag`})
              </div>
            ))}
          </div>
        )}
        {hasErrors && (
          <div style={{ marginTop: 15, fontStyle: 'italic' }}>
            {'Bitte passen Sie die Futterwerte an, bevor Sie fortfahren.'}
          </div>
        )}
      </div>
    }
  />
}

export default DryMatterValuesModal
